export { default } from './BaseTypeAhead';
